import { categories } from '@/mocks/comics';

export default function Categories() {
  const handleClick = (key: string) => {
    const list = document.querySelector<HTMLElement>('#comics');
    if (list) {
      list.scrollIntoView({ behavior: 'smooth' });
      list.dispatchEvent(new CustomEvent('comic:filter', { detail: key }));
    }
  };

  return (
    <section id="categories" className="w-full bg-background-50 py-14 md:py-20" aria-labelledby="categories-title">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-grid-fill" aria-hidden="true"></i>
              题材分类
            </span>
            <h2 id="categories-title" className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              你想看哪种好笑？
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              从校园到职场、从萌宠到美食，八个爆笑方向随便挑。点一下就能直达对应连载，笑点永远不迷路。
            </p>
          </div>
          <span className="hidden text-sm text-foreground-500 md:block">共收录 3280+ 部作品</span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {categories
            .filter((c) => c.key !== 'all')
            .map((c) => (
              <button
                key={c.key}
                type="button"
                onClick={() => handleClick(c.key)}
                className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 text-left transition-all hover:-translate-y-1 hover:border-primary-300 hover:bg-primary-50 md:p-5"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 md:h-14 md:w-14 md:text-2xl">
                  <i className={c.icon} aria-hidden="true"></i>
                </span>
                <span className="min-w-0">
                  <span className="flex items-center gap-2">
                    <span className="font-heading text-base text-foreground-950 md:text-lg">{c.name}</span>
                    <span className="rounded-full bg-background-200 px-2 py-0.5 text-xs text-foreground-600">{c.count}</span>
                  </span>
                  <span className="mt-1 block truncate text-xs text-foreground-500 md:text-sm">{c.desc}</span>
                </span>
              </button>
            ))}
        </div>
      </div>
    </section>
  );
}